'use client'

import React, { HTMLAttributes } from 'react'

import { Box, cn, VStack } from '@podo-app/design-system-temp'

import { useNativeBridgeStore } from '../../models'

const SafeAreaView = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const { useSafeArea } = useNativeBridgeStore()

  return (
    <React.Fragment>
      <Box className={cn('sticky top-0 bg-white z-40', useSafeArea ? 'h-[var(--safe-area-inset-top)]' : 'h-0')} />
      <VStack
        className={cn(
          'w-full mobile:min-w-[360px] tablet:max-w-[480px] m-auto bg-white overscroll-none',
          'min-h-[calc(100dvh-var(--safe-area-inset-top)-var(--safe-area-inset-bottom))] pl-[var(--safe-area-inset-left)] pr-[var(--safe-area-inset-right)]',
          'before:fixed before:inset-0 before:bg-white before:-z-10',
          className,
        )}
        {...props}
      >
        {children}
      </VStack>
      <Box className={cn('sticky bottom-0 bg-white z-40', useSafeArea ? 'h-[var(--safe-area-inset-bottom)]' : 'h-0')} />
    </React.Fragment>
  )
}

export default SafeAreaView
